module.exports = __webpack_public_path__ + "img/loading.ce797770.gif";